import styled from 'styled-components';
import { isPortrait } from '../../utils/size';

export const DonationAmountsContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-content: flex-end;
    position: relative;

    @media (max-width: 30em) {
        flex-wrap: wrap;
        justify-content: space-between;
        flex-direction: none;

        > div {
            margin-bottom: 0.5em;
        }
        > div:nth-child(1) {
            margin-right: 0.25em;
        }
        > div:nth-child(2) {
            margin-left: 0.25em;
        }
        > div:nth-child(3) {
            margin-right: 0.25em;
            margin-bottom: 0px;
        }
        > div:nth-child(4) {
            margin-left: 0.25em;
            margin-bottom: 0px;
        }
    }

    @media (min-width: 30.0625em) {
        flex-direction: row;
        padding-bottom: 8px;
        justify-content: space-between;
        align-items: flex-end;

        > div {
            margin-bottom: 1px;
        }
        > div:nth-child(1) {
            margin-right: 0.25em;
        }

        > div:nth-child(2) {
            margin-left: 0.25em;
            margin-right: 0.25em;
        }

        > div:nth-child(3) {
            margin-left: 0.25em;
            margin-right: 0.25em;
        }

        > div:nth-child(4) {
            margin-left: 0.25em;
        }
    }

    &.transition-enter {
        opacity: 0;
    }

    &.transition-enter.transition-enter-active {
        opacity: 1;
        transition: opacity 0.4s ease-in;
    }

    &.transition-exit {
        opacity: 1;
    }

    &.transition-exit.transition-exit-active {
        opacity: 0;
        transition: opacity 0.1s ease-in;
    }
`;
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (max-width: 30em) {
        ${props => (props.isCustomDonation ? 'max-height: calc(90% - 146px)' : '')};
    }
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    right: 0px;
    top: 12px;
    width: 135px;
    height: 32px;
    background: #fff;
`;

export const CloseButton = styled.div`
    width: 34px;
    height: 34px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 34px;
    cursor: pointer;
    color: #ff245e;
    float: right;
`;

export const AbsoluteContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const DonationWrapper = styled.div`
    display: flex;
    flex: 1;
    ${() => !isPortrait() && `align-items: center`};
    width: 100%;
    margin-bottom: 0px;
`;

export const Back = styled.span`
    cursor: pointer;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    color: #008eff;
`;
